import React, { useState, useEffect } from 'react';
import { UserPlus, Baby, Trophy, Settings, LogOut } from 'lucide-react';
import { getMyStudents } from '../api/studentApi';
import AddChildModal from '../components/AddChildModal';
import './SchoolDashboard.css';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const SchoolDashboard = () => {
  const { user, logoutUser } = useUser();
  const [students, setStudents] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const fetchStudents = async () => {
    try {
      const response = await getMyStudents();
      setStudents(response.data);
    } catch (err) {
      console.error("Failed to fetch students", err);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem('token');

    if (!token || user?.role !== 'school') {
      window.location.href = "/login";
      return;
    }

    fetchStudents();
  }, []);

  useEffect(() => {
    fetchStudents();
  }, []);

  const handleLogout = () => {
    // 1. Clear the token and user data from storage
    logoutUser();

    // 2. Optional: If you use a custom auth state/context, reset it here

    // 3. Redirect to the landing page or login
    navigate('/');
  };

  const showLeaderboard = () => {
    navigate('/leaderboards');
  };

  return (
    <div className="dashboard-container">
      <aside className="sidebar">
        <div className="sidebar-logo">Knolup</div>
        <nav>
          <button className="nav-item active"><Baby size={20} /> My Students</button>
          <button className="nav-item" onClick={showLeaderboard}><Trophy size={20} /> Leaderboard</button>
          <button className="nav-item"><Settings size={20} /> Settings</button>
        </nav>
        <button
          className="btn-primary btn-ghost logout-btn"
          onClick={handleLogout}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      </aside>

      <main className="dashboard-content">
        <header className="dashboard-header">
          <div>
            <h1>Welcome, {user?.username}! 👋</h1>
            <p>Manage your school's learning adventure.</p>
          </div>
          <button className="btn-add-child" onClick={() => setIsModalOpen(true)}>
            <UserPlus size={20} /> Add Student
          </button>
        </header>

        <div className="student-grid">
          {students.length > 0 ? (
            students.map((student) => (
              <div key={student.id} className="student-card">
                <div className="avatar-circle">
                  <Baby size={40} color="#6366f1" />
                </div>
                <h3>{student.username}</h3>
                <p className="grade-badge">{student.grade.name}</p> {/* New Badge */}
                <div className="student-stats">
                  <span><Trophy size={16} /> {student.points} Points</span>
                </div>
                <button className="btn-primary btn-view-progress" onClick={() => navigate(`/parent/student/${student.id}`)}>
                  View Progress
                </button>
              </div>
            ))
          ) : (
            <div className="empty-state">
              <Baby size={48} style={{ marginBottom: '1rem', opacity: 0.5 }} />
              <p>No student accounts created yet.<br /> Click <strong>"Add Student"</strong> to get started!</p>
            </div>
          )}
        </div>
      </main>

      {isModalOpen && (
        <AddChildModal
          onClose={() => setIsModalOpen(false)}
          onSuccess={() => {
            setIsModalOpen(false);
            fetchStudents();
          }}
        />
      )}
    </div>
  );
};

export default SchoolDashboard;